import React from 'react'

const TermsServiceArea = () => {
  return (
    <>
         <section id="terms_service" className="section_padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="terms_service_content">
                        <div className="terms_item">
                            <h4>Agreement</h4>
                            <p>
                                By using this website and participating in PCF — Pakistani Cultural &amp; Sports Organisation
                                activities (including badminton, seasonal sports, culture, education, and integration
                                programmes), you agree to these terms. If you do not agree, please do not use our services.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Activities and conduct</h4>
                            <p>
                                PCF aims to provide a respectful, safe environment for children, youth, and families. Parents
                                or guardians are responsible for children under their care. Participants and volunteers must
                                follow instructions from organisers and behave respectfully toward others. PCF may refuse
                                participation in case of serious misconduct.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Sports and health</h4>
                            <p>
                                Physical activities carry inherent risk. By joining sports programmes you confirm that
                                participants are in reasonable health for the activity. Please inform coaches of relevant
                                medical conditions. PCF is not liable for injuries except where mandatory Swedish law
                                applies.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Fees and cancellations</h4>
                            <p>
                                Some programmes may require a fee to cover costs. Refund and cancellation rules will be
                                communicated per activity. PCF may cancel or reschedule events due to weather, venue
                                availability, or force majeure.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Website content</h4>
                            <p>
                                Information on this site is provided in good faith and may change. We do not guarantee
                                uninterrupted access to the website. Links to third-party sites are for convenience; PCF is
                                not responsible for their content.
                            </p>
                        </div>
                        <div className="terms_item">
                            <h4>Contact</h4>
                            <p>
                                Questions about these terms: info@pcfsweden.se. PCF may update these terms; continued use
                                after changes constitutes acceptance.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default TermsServiceArea
